export type NavItemOption = {
  id: string;
  label: string;
  group: string;
};

export const NAV_ITEM_OPTIONS: NavItemOption[] = [
  { id: "home", label: "Home", group: "Home" },

  { id: "analytics-dashboard", label: "Performance Overview", group: "Analytics" },
  { id: "reports", label: "Reports", group: "Analytics" },

  { id: "safety-overview", label: "Safety Overview", group: "Safety" },
  { id: "flagged-videos", label: "Flagged Videos", group: "Safety" },
  { id: "configure-safety", label: "Configure Safety", group: "Safety" },

  { id: "creator-explorer", label: "Your Creators", group: "Creators" },
  { id: "candidate-explorer", label: "New Creators", group: "Creators" },
  { id: "creator-cohorts", label: "Cohorts", group: "Creators" },
  { id: "creator-tags", label: "Tags", group: "Creators" },
  { id: "blocked-creators", label: "Blocked Creators", group: "Creators" },
  { id: "activities", label: "Messages & Activity", group: "Creators" },
  { id: "sequences", label: "Automate Outreach", group: "Creators" },
  { id: "message-templates", label: "Message Templates", group: "Creators" },

  { id: "collabs-target", label: "Target", group: "Collabs" },
  { id: "collab-groups-target", label: "Target (groups)", group: "Collabs" },
  { id: "collabs-open", label: "Open", group: "Collabs" },
  { id: "collab-groups-open", label: "Open (groups)", group: "Collabs" },
  { id: "sample-requests", label: "Sample Requests", group: "Collabs" },

  { id: "video-explorer", label: "Videos", group: "Videos" },

  { id: "product-explorer", label: "All Products", group: "Products" },
  { id: "smart-briefs", label: "Smart Product Briefs", group: "Products" },

  { id: "merchant-details", label: "Merchant Details", group: "Settings" },
  { id: "team", label: "Team", group: "Settings" },
  { id: "integrations", label: "Integrations", group: "Settings" },
];

export const navItemOptionLabel = (navItemId: string): string => {
  const option = NAV_ITEM_OPTIONS.find((item) => item.id === navItemId);
  return option ? `${option.group} › ${option.label}` : navItemId;
};
